import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "sidebar-item-content__icon-wrapper" }
const _hoisted_3 = {
  key: 1,
  class: "sidebar-item-badge"
}
const _hoisted_4 = {
  key: 0,
  class: "sidebar__sub-menu__popup__container"
}
const _hoisted_5 = { class: "sidebar__sub-menu__popup__body__label" }

import { onMounted, onUnmounted, ref, watch } from 'vue';
import { i18n } from '@/i18n';
import SvgLoader from '@/utils/SvgLoader.vue';
import { RouterItem } from './interfaces/routerItems';
import { useRoute, useRouter } from 'vue-router';
import { removeTokenIfExpired } from '@/appLogic/tokenAroundManagement';
import { displaySessionErrorInfo } from '@/corePagesModule/components/InfoModal/displaySessionErrorInfo';


export default /*@__PURE__*/_defineComponent({
  __name: 'SideBarItemWithSubMenu',
  props: {
    routeItem: {},
    sideBarIndex: {}
  },
  setup(__props: any) {

const t = i18n.t;
const route = useRoute();
const router = useRouter();

const props = __props;

const isOpen = ref(false);

onMounted(() => {
  document.addEventListener('click', closeDropdown);
});

onUnmounted(() => {
  document.removeEventListener('click', closeDropdown);
});

/**
 * サブメニューの表示非表示を切り替える
 */
const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

/**
 * ドロップダウンを閉じる(バックグラウンドクリック時)
 * @param e - マウスイベント
 */
const closeDropdown = (e: MouseEvent) => {
  if (!(e.target as Element).closest(`#sidebar-item-${props.sideBarIndex}-sub-menu`)) {
    isOpen.value = false;
  }
};

/**
 * 対象のサイドバー項目が現在のページかどうかを返す処理
 * @param routeItem - 対象のサイドバー項目
 */
const activeSubMenuItem = (routeItem: RouterItem) => {
  // 現在のルートのネスト内に対象のパスが含まれていればアクティブ
  return route.matched.map((route) => route.path).includes(routeItem.to);
};

const handleClick = async (child: RouterItem) => {
  // ここでトークンチェック（Storeや関数を呼ぶ）
  const ok = await removeTokenIfExpired();

  if (ok) {
    router.push(child.to); // 正常ならそのまま遷移
  } else {
    // トークンが期限切れの場合はモーダルを表示してログイン画面に遷移させる
    await displaySessionErrorInfo();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    id: `sidebar-item-${_ctx.sideBarIndex}-sub-menu`,
    class: "sidebar-item-with-sub-menu-container"
  }, [
    _createElementVNode("button", {
      class: "sidebar-item-content",
      onClick: toggleDropdown
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.routeItem.icon)
          ? (_openBlock(), _createBlock(SvgLoader, {
              key: 0,
              class: "sidebar-item-content__icon-image",
              name: _ctx.routeItem.icon
            }, null, 8, ["name"]))
          : _createCommentVNode("", true),
        (_ctx.routeItem.badge && _ctx.routeItem.badge !== '')
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.routeItem.badge), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_i18n_t, {
        class: "sidebar-item-content__label-text i18n-break",
        keypath: _ctx.routeItem.name,
        tag: "p"
      }, {
        newLine: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("br", null, null, -1)
        ])),
        _: 1
      }, 8, ["keypath"])
    ]),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routeItem.expandChildren, (child, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["sidebar__sub-menu__popup__body", { 'sidebar__sub-menu__popup__body--active': activeSubMenuItem(child) }])
            }, [
              _createVNode(_component_router_link, {
                "data-testid": child.to == '/translate-excel' ? `sidebar-content_inventory_information` : '',
                to: child.to,
                onClick: [
                  toggleDropdown,
                  _withModifiers(($event: any) => (handleClick(child)), ["prevent"])
                ]
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)(child.longName ? child.longName : child.name)), 1)
                ], undefined, true),
                _: 2
              }, 1032, ["data-testid", "to", "onClick"])
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})